import {Component} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {ClusterEngineeringHeader} from "./cluster-engineering-header/cluster-engineering-header";
import {ClusterEngineeringInfoCard} from "./models/cluster-engineering-info-card";
import {BoxItemFlip} from "../../components/display/box-item-flip/box-item-flip"
@Component({
  selector: 'en-cluster-engineering',
  standalone: true,
  imports: [
    TranslateModule,
    ClusterEngineeringHeader,
    BoxItemFlip
  ],
  styleUrls: ['./cluster-engineering.scss'],
  templateUrl: 'en-cluster-engineering.html'
})
export class EnClusterEngineering {
  protected infoCards: ClusterEngineeringInfoCard[] = [
    {
      title: 'VESYSCO',
      imgClass: 'flip-card-cluster-engineering-10',
      content: 'At BMW TechWorks Romania, in the VESYSCO unit, we accelerate BMW’s transformation toward fully virtual development.\n' +
        'By leveraging the 3DExperience platform and powerful CAD tools like CATIA, we streamline engineering, reduce physical hardware, and enhance overall product quality.\n' +
        'We build the digital tools and virtual environments that enable faster, smarter decisions throughout the development process.\n' +
        'V1 Silviu Cândea- Unit Head VESYSCO\n' +
        'And together with our BMW colleagues,we’re making virtual development the standard and driving innovation that shapes the future of every BMW on the road.'
    }, {
      title: 'PDM&EE',
      imgClass: 'flip-card-cluster-engineering-4',
      content: 'In PDM&EE unit, our focus is on giving BMW engineers a clear, accurate, “single source of truth” for all vehicle master data.\n' +
        'Because when the data is clean, consistent, and accessible, innovation moves faster — and decisions become smarter.\n' +
        '\n' +
        'Inside the EE area, we work at the intersection of collaboration and cutting-edge technology.\n' +
        'Our teams empower engineers to design and validate the electrical and electronic systems that define the modern BMW driving experience — from core architecture to the smallest signal flow.\n' +
        '\n' +
        'To make this possible, we rely on advanced technologies like Java, .NET, Angular, and cloud solutions such as AWS and Azure. By leveraging these tools, we provide seamless, scalable, and secure platforms that enable our engineers to innovate with confidence and agility. Together, we drive the future of mobility, ensuring every BMW delivers exceptional quality, connectivity, and performance.'
    }
  ];

}
